import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import videocontext from "../../../../assets/videos/blogs/pp24/video-context-menu.mp4";
import resizepane from "../../../../assets/videos/blogs/pp24/resize.mp4";
import threedview from "../../../../assets/images/docs/debugtools/3dview.mp4";
import customize2 from "../../../../assets/images/docs/tabs/customize2.png";
import video1 from "../../../../assets/videos/recording/video1.mp4";
import video2 from "../../../../assets/videos/recording/video2.mp4";
import focusstyle from "../../../../assets/images/blogs/pp24/focus.png";
import sortableSocials from "../../../../assets/videos/docs/meta/sortable-socials.mp4";
import sortingWorkspaces from "../../../../assets/videos/docs/workspaces/sorting-workspaces.mp4";
import mastodonauthor from "../../../../assets/images/blogs/pp24/mastodon.jpg";
import slackhtml from "../../../../assets/images/blogs/pp24/slackhtml.png";
import accnamewarning from "../../../../assets/images/blogs/pp24/accname.png";
import debugpanel2 from "../../../../assets/images/docs/elements/debugpanel.png";
import accpanelwording from "../../../../assets/images/blogs/pp24/accpanelwording.png";
import screenshotdefaultaction from "../../../../assets/images/docs/screenshots/defaultaction.png";
import rescantargetsize from "../../../../assets/images/blogs/pp24/rescantargetsize.png";
import edithtml from "../../../../assets/videos/docs/elements/edit-html.mp4";
import * as React from 'react';
export default {
  ShortCutDisplay,
  videocontext,
  resizepane,
  threedview,
  customize2,
  video1,
  video2,
  focusstyle,
  sortableSocials,
  sortingWorkspaces,
  mastodonauthor,
  slackhtml,
  accnamewarning,
  debugpanel2,
  accpanelwording,
  screenshotdefaultaction,
  rescantargetsize,
  edithtml,
  React
};